import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient, { publicApiClient } from '@/core/api/client'
import { InviteUserRequestDTO } from '@/core/api/dtos/request/auth/invite'
import { LoginRequestDTO } from '@/core/api/dtos/request/auth/login'
import { LoginWithTokenRequestDTO } from '@/core/api/dtos/request/auth/loginWithToken'
import { PasswordRecoveryRequestDTO } from '@/core/api/dtos/request/auth/passwordRecovery'
import { PasswordResetRequestDTO } from '@/core/api/dtos/request/auth/passwordReset'
import { RegisterRequestDTO } from '@/core/api/dtos/request/auth/register'
import { LoginResponseDTO } from '@/core/api/dtos/response/auth/login'

import { LoginGoogleRequestDTO } from '../dtos/request/auth/loginGoogle'

export const authService = {
	/**
	 * Login a user with email and password
	 */
	login(
		data: LoginRequestDTO,
		config?: AxiosRequestConfig
	): Promise<LoginResponseDTO> {
		return publicApiClient
			.post('/auth/token', data, config)
			.then((response) => {
				return {
					token: response.data.token,
				}
			})
	},

	/**
	 * Refresh the access token
	 */
	refreshToken(config?: AxiosRequestConfig): Promise<LoginResponseDTO> {
		return apiClient.post('/auth/refresh', config)
	},

	/**
	 * Forgot password
	 */
	forgotPassword(
		data: PasswordRecoveryRequestDTO,
		config?: AxiosRequestConfig
	): Promise<void> {
		return publicApiClient.post('/auth/password/forgot', data, config)
	},

	/**
	 * Reset password
	 */
	resetPassword(
		data: PasswordResetRequestDTO,
		config?: AxiosRequestConfig
	): Promise<void> {
		return publicApiClient.post('/auth/password/reset', data, config)
	},

	register: (
		data: RegisterRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> => {
		return publicApiClient.post('/self/register', data, config)
	},

	/**
	 * Invite a user to an account
	 */
	invite(
		data: InviteUserRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post('/auth/invite', data, config)
	},

	/**
	 * Login with a token (for login as user feature)
	 */
	loginWithToken(
		data: LoginWithTokenRequestDTO,
		config?: AxiosRequestConfig
	): Promise<LoginResponseDTO> {
		return apiClient
			.post('/auth/token/token', data, config)
			.then((response) => {
				return {
					token: response.data.token,
				}
			})
	},

	/**
	 * Exchange a Google OAuth authorization code and related params
	 * for an application access token on our backend.
	 */
	loginWithGoogle(
		data: LoginGoogleRequestDTO,
		config?: AxiosRequestConfig
	): Promise<LoginResponseDTO> {
		return publicApiClient
			.post('/auth/token/google/callback', data, config)
			.then((response: AxiosResponse<LoginResponseDTO>) => {
				return response.data
			})
	},
}

export default authService
